let KeyMap = [
  {
    key: "C",
    camelot: {
      0: "5A",
      1: "8B",
    },
    open: {
      0: "10m",
      1: "1d",
    },
  },
  {
    key: "C♯/D♭",
    camelot: {
      0: "12A",
      1: "3B",
    },
    open: {
      0: "5m",
      1: "8d",
    },
  },
  {
    key: "D",
    camelot: {
      0: "7A",
      1: "10B",
    },
    open: {
      0: "12m",
      1: "3d",
    },
  },
  {
    key: "D♯/E♭",
    camelot: {
      0: "2A",
      1: "5B",
    },
    open: {
      0: "7m",
      1: "10d",
    },
  },
  {
    key: "E",
    camelot: {
      0: "9A",
      1: "12B",
    },
    open: {
      0: "2m",
      1: "5d",
    },
  },
  {
    key: "F",
    camelot: {
      0: "4A",
      1: "7B",
    },
    open: {
      0: "9m",
      1: "12d",
    },
  },
  {
    key: "F♯/G♭",
    camelot: {
      0: "11A",
      1: "2B",
    },
    open: {
      0: "4m",
      1: "7d",
    },
  },
  {
    key: "G",
    camelot: {
      0: "6A",
      1: "9B",
    },
    open: {
      0: "11m",
      1: "2d",
    },
  },
  {
    key: "G♯/A♭",
    camelot: {
      0: "1A",
      1: "4B",
    },
    open: {
      0: "6m",
      1: "9d",
    },
  },
  {
    key: "A",
    camelot: {
      0: "8A",
      1: "11B",
    },
    open: {
      0: "1m",
      1: "4d",
    },
  },
  {
    key: "A♯/B♭",
    camelot: {
      0: "3A",
      1: "6B",
    },
    open: {
      0: "8m",
      1: "11d",
    },
  },
  {
    key: "B",
    camelot: {
      0: "10A",
      1: "1B",
    },
    open: {
      0: "3m",
      1: "6d",
    },
  },
];

export default KeyMap;
